import api from './api';
import API_CONFIG from '../config/api.config';

export const authService = {
  async login(login, senha) {
    try {
     //console.log('Tentando login com:', { login, senha });
     //console.log('URL da API:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.LOGIN);
      
      const response = await api.post(API_CONFIG.ENDPOINTS.LOGIN, { login, senha });
     //console.log('Resposta completa da API de login:', response);
     //console.log('Dados da resposta de login:', response.data);
      
      const { token, user, prefeitura, fornecedor } = response.data;
      
     //console.log('Token recebido da API de login:', token);
      
      // Salvar dados no localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('tipoUsuario', user.USU_TIPO);
      localStorage.setItem('idUsuario', user.USU_ID);
     
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      }

      if (prefeitura) {
        localStorage.setItem('idPrefeitura', prefeitura.PRE_ID);
        localStorage.setItem('prefeitura', JSON.stringify(prefeitura));
        localStorage.setItem('nomePrefeitura', prefeitura.PRE_NOME);
      }

      if (fornecedor) {
        localStorage.setItem('idFornecedor', fornecedor.FOR_ID);
        localStorage.setItem('fornecedor', JSON.stringify(fornecedor));
        localStorage.setItem('nomeFornecedor', fornecedor.FOR_RAZAO_SOCIAL);
      }

      return user;
    } catch (error) {
      // console.error('Erro no login:', error);
      // console.error('Detalhes do erro:', {
      //   status: error.response?.status,
      //   data: error.response?.data,
      //   message: error.message
      // });
      // (pode adicionar tratamento de erro aqui se necessário)
    }
  },

  logout() {
    localStorage.clear();
    window.location.href = '/login';
  },

  isAuthenticated() {
    const token = localStorage.getItem('token');
    return !!token;
  },

  getToken() {
    return localStorage.getItem('token');
  },

  getUserType() {
    return localStorage.getItem('tipoUsuario');
  },

  getUserId() {
    return localStorage.getItem('idUsuario');
  },

  getPrefeituraId() {
    return localStorage.getItem('idPrefeitura');
  },

  getFornecedorId() {
    return localStorage.getItem('idFornecedor');
  }
}; 